//
//
//
//
//
//
//

export default {
    name: "tool-tip",
    props: {
        effect: {
            type: String,
            default: "light"
        },
        placement: {
            type: String,
            default: "top"
        },
        content: {
            type: String,
            default: "tool tip"
        },
        hideAfter: {
            type: Number,
            default: 0
        },
       disabled:{
            type:Boolean,
            default:false
        }
    },
    methods: {
        toBreak(val) {
            return val.split("\n").join("<br/>");
        }
    },
    computed: {
       readonly:function(){
            if(this.content=="tool tip"||this.disabled){
               return true;
             }else{
                 return false;
             }
       } 
    }
   
    
}



// WEBPACK FOOTER //
// ./src/pccomponents/ToolTip.vue